import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useLink } from '../../hooks/useLink.js';
import { Img } from '../../ui-kit/Img/Img.js';
import { style } from '../../utils/style.js';
export const CarouselLinkButton = JSX(({ icon, ...linkProps }) => {
    const link = useLink();
    const { text, href, target, onClick } = link(linkProps);
    const textStyle = 'font-light md:font-normal text-primary-text text-center text-xs md:text-sm whitespace-wrap';
    return text ? (_jsx("div", { className: style('p-3 rounded-lg bg-white text-secondary-text flex justify-center'), children: _jsx("a", { role: "link", href: href, target: target, onClick: onClick, children: _jsxs("div", { className: "flex flex-col items-center gap-3 break-words max-w-[150px]", children: [icon ? (_jsx(Img, { className: "w-7 h-7 md:w-12 md:h-12", image: {
                            ...icon,
                            iconVersion: icon?.iconVersion,
                        }, alt: text })) : null, _jsx("div", { className: textStyle, children: text })] }) }) })) : null;
});
//# sourceMappingURL=CarouselLinkButton.js.map